<template>
    <a 
        :href="`tel:${telNumber ? telNumber : '02038460003'}`"
        @click="customEvent('Dealer Locator', 'Phone number', 'Clicked')"
    >
        {{ displayNumber ? displayNumber : telNumber ? telNumber : '024 7685 1458' }}
    </a>
</template>

<script>
    import { defineComponent } from "vue";
    import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

    export default defineComponent({
        name: 'MediaHawkNumber',

        props: {
            telNumber: String,
            displayNumber: String
        },

        methods: {
            customEvent: customEvent
        }
    })
</script>